import { BuyersPremium, EmptyBuyersPremium } from './BuyersPremium';
import { $Values } from 'utility-types';
import type { AuctionStatus } from '@/types/LiveAuctionState';
import { PaymentOption } from './PaymentOption';
import paymentProviders from '@/enums/paymentProviders';

export type CatalogAddress = {
    address: string;
    address2: string;
    city: string;
    country: string;
    fullCountryName: string;
    lat: number;
    lng: number;
    postalCode: string;
    state: string;
};

export type Catalog = {
    absenteeBidders: number;
    achPayments: boolean;
    address: CatalogAddress;
    buyersPremium: BuyersPremium;
    catalogId: number;
    catalogStatus: AuctionStatus;
    currency: string;
    currencySymbol: string;
    description: string;
    hasExplicitMaterial: boolean;
    hasVideo: boolean;
    highRiskPayments: boolean;
    imagePath: string;
    isAutopay: boolean;
    isCatalogOnly: boolean;
    isSEOExcluded: boolean;
    isTimed: boolean;
    liveAuctioneersPayments: boolean;
    lotsListed: number;
    paymentOptions?: PaymentOption;
    paymentProvider?: $Values<typeof paymentProviders>;
    payrixPayments: boolean;
    preview: string;
    publishDateTs?: number;
    saleEndTs: number;
    saleStartTs: number;
    sellerId: number;
    title: string;
};

export const EmptyCatalog = {
    absenteeBidders: 0,
    achPayments: false,
    address: {
        address: '',
        address2: '',
        city: '',
        country: '',
        fullCountryName: '',
        lat: 0,
        lng: 0,
        postalCode: '',
        state: '',
    },
    buyersPremium: EmptyBuyersPremium,
    catalogId: 0,
    catalogStatus: 'done',
    currency: '',
    currencySymbol: '',
    description: '',
    hasExplicitMaterial: false,
    hasVideo: false,
    highRiskPayments: false,
    imagePath: '',
    isAutopay: false,
    isCatalogOnly: false,
    isSEOExcluded: false,
    isTimed: false,
    liveAuctioneersPayments: false,
    lotsListed: 0,
    payrixPayments: false,
    preview: '',
    publishDateTs: 0,
    saleEndTs: 0,
    saleStartTs: 0,
    sellerId: 0,
    title: '',
};
